module.exports = __webpack_public_path__ + "img/img-intersection.5cfd9689.png";